<template>
  <div class="casino-header">
      <SelectBox>
        <template slot="button">Sağlayıcı Seçin 
          <svg x="0px" y="0px" viewBox="0 0 490 490" style="enable-background:new 0 0 490 490;" xml:space="preserve"> <g> <g> <polygon points="490,157.332 244.996,407.369 0,157.332 76.493,82.631 244.996,254.598 413.507,82.631   "/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>
        </template>
        <template slot="title">Sağlayıcılar</template>
        <template slot="content">
          <Providers/>
        </template>
      </SelectBox>
      <div class="active-provider">
          <div class="game">
            <h4 class="line-title">{{ currentProvider }}</h4>
          </div>
      </div>
  </div>
</template>

<script>
    import Providers from './Providers'
    import SelectBox from '../Common/SelectBox'
    export default{
      computed:{
        currentProvider(){
          return this.$store.getters['virtual/getCurrentProvider'];
        }
      },
      components:{
        Providers,
        SelectBox
      }
    }
</script>